import './Icon.css'

import { ComponentType, lazy, Suspense } from 'react'

import { cx } from '../utilities/cx'
import { icons, IconName } from '../icons'

export type { IconName }

const cache = new Map<IconName, ComponentType>()

function getIcon(name: IconName) {
  if (!cache.has(name)) {
    cache.set(name, lazy(icons[name]))
  }
  return cache.get(name)!
}

export type IconProps = {
  className?: string
  name: IconName
}

export const Icon = (props: IconProps) => {
  const { className, name } = props

  const IconComponent = getIcon(name)

  return (
    <span className={cx('icon', className)}>
      <Suspense fallback={null}>
        <IconComponent />
      </Suspense>
    </span>
  )
}
